export const localStorageService = () => {
  const USER_ID = 'userId';
  const UN_USER_ID = 'un_userId';
  const ACCESS_TOKEN = 'accessToken';
  const REFRESH_TOKEN = 'refreshToken';
  const HAS_SHOWN_BIOMETRIC_DRAWER = 'hasShownBiometricDrawer';
  const REDIRECT_URL = 'redirectUrl';
  const PENDING_PHONE = 'pendingPhone';
  const PENDING_EMAIL = 'pendingEmail';

  const getUserId = () => localStorage.getItem(USER_ID);
  const setUserId = (id: string) => localStorage.setItem(USER_ID, id);
  const removeUserId = () => localStorage.removeItem(USER_ID);

  const getUnverifiedUserId = () => localStorage.getItem(UN_USER_ID);
  const setUnverifiedUserId = (id: string) =>
    localStorage.setItem(UN_USER_ID, id);
  const removeUnverifiedUserId = () => localStorage.removeItem(UN_USER_ID);

  const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN);
  const setAccessToken = (token: string) =>
    localStorage.setItem(ACCESS_TOKEN, token);
  const removeAccessToken = () => localStorage.removeItem(ACCESS_TOKEN);

  const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN);
  const setRefreshToken = (token: string) =>
    localStorage.setItem(REFRESH_TOKEN, token);
  const removeRefreshToken = () => localStorage.removeItem(REFRESH_TOKEN);

  const getMeterValue = (connectorId?: number) =>
    localStorage.getItem(connectorId ? `meterValue_${connectorId}` : 'meterValue');
  const setMeterValue = (values: string, connectorId?: number) =>
    localStorage.setItem(connectorId ? `meterValue_${connectorId}` : 'meterValue', values);
  const removeMeterValue = (connectorId?: number) =>
    localStorage.removeItem(connectorId ? `meterValue_${connectorId}` : 'meterValue');

  const getHasShownBiometricDrawer = () => {
    const value = localStorage.getItem(HAS_SHOWN_BIOMETRIC_DRAWER);
    return value ? JSON.parse(value) : false;
  };
  const setHasShownBiometricDrawer = (value: boolean) =>
    localStorage.setItem(HAS_SHOWN_BIOMETRIC_DRAWER, JSON.stringify(value));

  const removeHasShownBiometricDrawer = () =>
    localStorage.removeItem(HAS_SHOWN_BIOMETRIC_DRAWER);

  const getRedirectUrl = () => localStorage.getItem(REDIRECT_URL);
  const setRedirectUrl = (url: string) =>
    localStorage.setItem(REDIRECT_URL, url);
  const removeRedirectUrl = () => localStorage.removeItem(REDIRECT_URL);

  const getPendingPhone = () => localStorage.getItem(PENDING_PHONE);
  const setPendingPhone = (phone: string) =>
    localStorage.setItem(PENDING_PHONE, phone);
  const removePendingPhone = () => localStorage.removeItem(PENDING_PHONE);

  const getPendingEmail = () => localStorage.getItem(PENDING_EMAIL);
  const setPendingEmail = (email: string) =>
    localStorage.setItem(PENDING_EMAIL, email);
  const removePendingEmail = () => localStorage.removeItem(PENDING_EMAIL);

  // Session storage for pre-filled kWh value (expires after 1 minute)
  const PREFILLED_KWT_KEY = 'prefilledKwt';
  const PREFILLED_KWT_EXPIRY_KEY = 'prefilledKwtExpiry';
  const KWT_EXPIRY_TIME = 60 * 1000; // 1 minute in milliseconds

  const getPrefilledKwt = (): string | null => {
    const expiry = sessionStorage.getItem(PREFILLED_KWT_EXPIRY_KEY);
    if (expiry && Date.now() > parseInt(expiry)) {
      // Expired, clean up
      sessionStorage.removeItem(PREFILLED_KWT_KEY);
      sessionStorage.removeItem(PREFILLED_KWT_EXPIRY_KEY);
      return null;
    }
    return sessionStorage.getItem(PREFILLED_KWT_KEY);
  };

  const setPrefilledKwt = (kwt: string) => {
    sessionStorage.setItem(PREFILLED_KWT_KEY, kwt);
    sessionStorage.setItem(
      PREFILLED_KWT_EXPIRY_KEY,
      (Date.now() + KWT_EXPIRY_TIME).toString(),
    );
  };

  const removePrefilledKwt = () => {
    sessionStorage.removeItem(PREFILLED_KWT_KEY);
    sessionStorage.removeItem(PREFILLED_KWT_EXPIRY_KEY);
  };

  return {
    getUserId,
    setUserId,
    removeUserId,
    getAccessToken,
    getRefreshToken,
    setAccessToken,
    removeAccessToken,
    setRefreshToken,
    removeRefreshToken,
    getUnverifiedUserId,
    setUnverifiedUserId,
    removeUnverifiedUserId,
    getHasShownBiometricDrawer,
    setHasShownBiometricDrawer,
    removeHasShownBiometricDrawer,
    getMeterValue,
    setMeterValue,
    removeMeterValue,
    getRedirectUrl,
    setRedirectUrl,
    removeRedirectUrl,
    getPendingPhone,
    setPendingPhone,
    removePendingPhone,
    getPendingEmail,
    setPendingEmail,
    removePendingEmail,
    getPrefilledKwt,
    setPrefilledKwt,
    removePrefilledKwt,
  };
};
